module.exports = __webpack_public_path__ + "img/share-twitter.ae049e18.svg";